import { render, staticRenderFns } from "./LeaveComments.vue?vue&type=template&id=cf8894aa"
import script from "./LeaveComments.vue?vue&type=script&lang=js"
export * from "./LeaveComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports